export default __webpack_public_path__ + "static/media/myexam.b4652fea.svg";